(function ($, _) {
    function ajaxFailHandler(errResp) {
        var responseJson = JSON.parse(errResp.responseText);
        var message = responseJson.Message ? responseJson.Message : errResp.statusText;
        window.PubSub.publish('notification.error', message);
    };

    //#region Jquery extensions
    /* Check that value in textbox higher or equal to minimum quantity */
    $.minQuantityCheck = function (txbsel, minqty, msgcontsel, msg) {
        var t = $(txbsel);
        var c = $(msgcontsel);
        t.keyup(function () {
            c.find('span.MinQtyError').remove();
            c.find('span').filter(function () { return $(this).text() == msg; }).remove();

            if (t.length > 0 && t.val().length > 0 && parseFloat(t.val().replace(',', '.')) < parseFloat(minqty)) {
                c.append('<span class="MinQtyError ErrMsg">' + msg + '</span>');
            }

            //Retrigger set equal hights
            window.SetEqualHeights();
        });
    };

    /* Bring postal code lookup */
    $.getPostalCodeInfo = function (postalCode, callback) {
        if (!postalCode || postalCode.length !== 4 || $.isNumeric(postalCode) === false) {
            if (callback) {
                callback({ result: "Ugyldig postnummer", valid: false });
            }

            return;
        }

        if (postalCode.length === 4) {
            var url = "//fraktguide.bring.no/fraktguide/api/postalCode.json?country=no&pnr=" + postalCode + "&callback=?";
            $.getJSON(url, callback);
        }
    };

    /* Dimension details loader */
    $.dimLoader = function (options) {
        var o = $.extend({
            itemId: 0,
            imgWidth: 120,
            imgMod: 'crop=none',
            drp1: '',
            drp2: '',
            drp3: '',
            prodNo: '',
            stock: '',
            price: '',
            orig: '',
            disc: '',
            image: '',
            error: '',
            buyRow: '',
            priceFrom: '',
            loadImg: window.R + 'Startup/Pics/wait3.gif',
            //usePrice: 1, <-- PriceField SHOULD NOT BE HARDCODED (UMWC-319)
            errHandler: null,
            okHandler: null
        }, options || {});

        var loadImg = '<img alt="loading..." src="' + o.loadImg + '" />';
        var d1 = $(o.drp1),
        d2 = $(o.drp2),
        d3 = $(o.drp3),
        drp = d1.add(d2).add(d3),
        prodNo = $(o.prodNo),
        stock = $(o.stock),
        price = $(o.price),
        orig = $(o.orig),
        disc = $(o.disc),
        image = $(o.image),
        error = $(o.error),
        buyRow = $(o.buyRow);

        if (drp.length > 0) {
            //Hookup change event
            drp.change(function () {
                //Set loading image
                prodNo.add(stock).add(price).add(orig).add(disc).html(loadImg);

                //Check if all dims are selected
                var allSel = drp.filter(function () { return jQuery("option:selected", this).val() !== "0"; }).length === drp.length;

                //Fetch dim details
                $.publicFetch({
                    handler: "ProductData",
                    data: {
                        a: "GetDimDetails",
                        ItemID: o.itemId,
                        Dim1: d1.length > 0 ? d1.find("option:selected").val() : "0",
                        Dim2: d2.length > 0 ? d2.find("option:selected").val() : "0",
                        Dim3: d3.length > 0 ? d3.find("option:selected").val() : "0",
                        ImageWidth: o.imgWidth,
                        ImgMod: o.imgMod,
                        usePrice: o.usePrice
                    },
                    success: function (d) {
                        //Allow buy
                        buyRow.css("display", d.AllowBuy === true || allSel === false ? "" : "none");
                        //Product number
                        prodNo.text(d.ProdNo);
                        //Stock text
                        stock.text(d.StockText);
                        stock.css("color", d.StockColor);
                        //Price
                        price.text((allSel === false ? o.priceFrom : "") + d.Price);
                        //Original price
                        orig.text(d.OriginalPrice);
                        //Discount price
                        disc.text(d.Discount);
                        //Image
                        if (d.ImageURL.length > 0) {
                            //Set image url
                            image.attr("src", d.ImageURL);
                            // Set link to image src
                            if (d.ImageLBURL) {
                                image.closest('a.ImageLink').attr('href', d.ImageLBURL).attr('title', d.ImageText ? d.ImageText : d.ProdNo);
                            }
                        }

                        if (o.okHandler && $.isFunction(o.okHandler)) {
                            o.okHandler.call(this, d);
                        }

                        if (typeof (window.PubSub) !== 'undefined') {
                            window.PubSub.publish('product.dimproduct.update', d);
                        }
                    },
                    error: function (err) {
                        if (error.hasClass('ErrMsg')) { error.text(err.Message); }
                        else {
                            if (error.find('.ErrMsg').length > 0) { error.find('.ErrMsg').text(err.Message); }
                            else { error.append('<span class="ErrMsg">' + err.Message + '</span>'); }
                        }

                        prodNo.add(stock).add(price).add(orig).add(disc).html("");

                        if (o.errHandler && $.isFunction(o.errHandler)) {
                            o.errHandler.call(this, err);
                        }
                    }
                });
            });
        }
    };
    $.loadDimProdInfo = function (options) {
        var o = $.extend({
            itemId: 0,
            imgWidth: 120,
            imgMod: 'crop=none',
            dim1Val: '',
            dim2Val: '',
            dim3Val: '',
            prodNo: '',
            stock: '',
            price: '',
            orig: '',
            disc: '',
            image: '',
            error: '',
            buyRow: '',
            origRow: '',
            discRow: '',
            priceFrom: '',
            loadImg: window.R + 'Startup/Pics/wait3.gif',
            //usePrice: 1, <-- PriceField SHOULD NOT BE HARDCODED (UMWC-319)
            loadDimProdImg: true,
            additionalReqParams: {},
            dimImageShouldDifferFromMain: false,
            mainProdImageId: 0,
            errHandler: null,
            okHandler: null,
            priceVisible: true
        }, options || {});

        var loadImg = '<img alt="loading..." src="' + o.loadImg + '" />',
            prodNo = $(o.prodNo),
            stock = $(o.stock),
            price = $(o.price),
            orig = $(o.orig),
            disc = $(o.disc),
            image = $(o.image),
            error = $(o.error),
            buyRow = $(o.buyRow),
            origRow = $(o.origRow),
            discRow = $(o.discRow);

        //Set loading image
        prodNo.html(loadImg);

        var reqParams = $.extend(o.additionalReqParams, {
            a: "GetDimDetails",
            ItemID: o.itemId,
            Dim1: o.dim1Val ? o.dim1Val : "0",
            Dim2: o.dim2Val ? o.dim2Val : "0",
            Dim3: o.dim3Val ? o.dim3Val : "0",
            ImageWidth: o.imgWidth,
            ImgMod: o.imgMod,
            usePrice: o.usePrice,
            priceVisible: o.priceVisible
        });

        //Fetch dim details
        $.publicFetch({
            handler: "ProductData",
            data: reqParams,
            success: function (d) {
                //Allow buy
                buyRow.css("display", d.AllowBuy === true ? "" : "none");
                //Product number
                prodNo.text(d.ProdNo);
                //Stock text
                stock.text(d.StockText);
                stock.css("color", d.StockColor);
                //Price
                var $priceText = price.find('.notranslate, .PriceValue');
                if ($priceText.length > 0) {
                    $priceText.html(d.Price);
                } else {
                    // Try to keep VAT text if found
                    price.contents().filter(function () { return this.className != 'PriceVatTxt'; }).remove();
                    price.prepend(document.createTextNode(d.Price + ' '));
                }
                price.find('.notranslate.PriceValue.ExclVat').html(d.PriceExclVat);
                price.find('.notranslate.PriceValue.InclVat').html(d.PriceInclVat);

                if (d.HasDiscount) {
                    origRow.show();
                    discRow.show();
                    //Original price
                    var $origPriceText = orig.find('.notranslate, .OriginalPriceValue');
                    if ($origPriceText.length > 0) {
                        $origPriceText.text(d.OriginalPrice);
                    } else {
                        // Try to keep VAT text if found
                        orig.contents().filter(function() { return this.className != 'PriceVatTxt'; }).remove();
                        orig.prepend(document.createTextNode(d.OriginalPrice + ' '));
                    }
                    //Discount price
                    var $discountText = disc.find('.notranslate, .DiscountValue');
                    if ($discountText.length > 0) {
                        $discountText.text(d.Discount);
                    } else {
                        // Try to keep VAT text if found
                        disc.contents().filter(function() { return this.className != 'PriceVatTxt'; }).remove();
                        disc.prepend(document.createTextNode(d.Discount + ' '));
                    }
                } else {
                    origRow.hide();
                    discRow.hide();
                }
                //Image
                if (d.ImageURL.length > 0 && o.loadDimProdImg && !(o.dimImageShouldDifferFromMain && d.ImageID == o.mainProdImageId)) {
                    //Set image url
                    image.attr("src", d.ImageURL);
                    if (d.ImageMaxWidth) {
                        image.css('max-width', d.ImageMaxWidth + 'px');
                    }
                    // Set link to image src
                    if (d.ImageLBURL) {
                        image.closest('a.ImageLink').attr('href', d.ImageLBURL).attr('title', d.ImageText ? d.ImageText : d.ProdNo);
                    }
                }
                // Replacement product
                if (d.ReplacementProductInfo) {
                    if (o.context) {
                        o.context.find('.ReplacementProductRow').empty().html(d.ReplacementProductInfo).show();
                    }

                    window.PubSub.publish('notification.warning', d.ReplacementProductInfo);
                } else {
                    if (o.context) {
                        o.context.find('.ReplacementProductRow').empty().hide();
                    }
                }

                if (o.okHandler && $.isFunction(o.okHandler)) {
                    o.okHandler.call(this, d);
                }

                if (typeof (window.PubSub) !== 'undefined') {
                    window.PubSub.publish('product.dimproduct.update', d);
                }
            },
            error: function (err) {
                if (error.hasClass('ErrMsg')) { error.text(err.Message); }
                else {
                    if (error.find('.ErrMsg').length > 0) { error.find('.ErrMsg').text(err.Message); }
                    else { error.append('<span class="ErrMsg">' + err.Message + '</span>'); }
                }

                prodNo.add(stock).add(price).add(orig).add(disc).html("");
                if (o.errHandler && $.isFunction(o.errHandler)) {
                    o.errHandler.call(this, err);
                }
            }
        });
    };

    /* Auto-grow input */
    $.fn.autoGrowInput = function (o) {
        o = $.extend({
            maxWidth: 1000,
            minWidth: 0,
            comfortZone: 70
        }, o);

        this.filter('input:text').each(function () {
            var minWidth = o.minWidth || $(this).width(),
                val = '',
                input = $(this),
                testSubject = $('<div/>').css({
                    position: 'absolute',
                    top: -9999,
                    left: -9999,
                    width: 'auto',
                    fontSize: input.css('fontSize'),
                    fontFamily: input.css('fontFamily'),
                    fontWeight: input.css('fontWeight'),
                    letterSpacing: input.css('letterSpacing'),
                    whiteSpace: 'nowrap'
                }),
                check = function () {
                    if (val === (val = input.val())) { return; }

                    // Enter new content into testSubject
                    var escaped = val.replace(/&/g, '&amp;').replace(/\s/g, '&nbsp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                    testSubject.html(escaped);

                    // Calculate new width + whether to change
                    var testerWidth = testSubject.width(),
                        newWidth = (testerWidth + o.comfortZone) >= minWidth ? testerWidth + o.comfortZone : minWidth,
                        currentWidth = input.width(),
                        isValidWidthChange = (newWidth < currentWidth && newWidth >= minWidth) || (newWidth > minWidth && newWidth < o.maxWidth);

                    // Animate width
                    if (isValidWidthChange) {
                        input.width(newWidth);
                    }
                };

            testSubject.insertAfter(input);

            $(this).bind('keyup keydown blur update', check);
        });

        return this;
    };

    /* Public AJAX fetch */
    $.publicFetch = function (options) {
        //Build options
        options = $.extend({
            handler: "",
            data: {},
            success: undefined,
            error: undefined,
            complete: undefined,
            type: 'GET'
        }, options || {});

        //Shorthand
        var o = options;

        //Append page and item id
        o.data.BasePageID = BasePageID;
        o.data.BaseItemID = BaseItemID;

        //Ajax
        if (o.handler.length > 0) {
            return $.ajax({
                url: window.R + "Handlers/Public/" + o.handler + ".ashx",
                data: o.data,
                success: function(data) {
                    if (o.success !== undefined) {
                        o.success(data);
                    }
                },
                error: function(err, type) {
                    //Parse error message
                    var msg;
                    try {
                        msg = $.parseJSON(err.responseText);
                    } catch (ex) {
                        msg = { Message: err.responseText };
                    }

                    //Call error callback
                    if (o.error !== undefined) {
                        o.error(msg || {}, type);
                    }
                },
                complete: options.complete,
                type: options.type
            });
        } else {
            throw 'A handler was not defined in the options when calling publicFetch';
        }
    };

    /* Cookie */
    $.cookie = function (key, value, options) {
        // key and value given, set cookie...
        if (arguments.length > 1 && (value === null || typeof value !== "object")) {
            options = $.extend({}, options);

            if (value === null) {
                options.expires = -1;
            }

            if (typeof options.expires === 'number') {
                var days = options.expires, t = options.expires = new Date();
                t.setDate(t.getDate() + days);
            }

            return (document.cookie = [
                encodeURIComponent(key), '=',
                options.raw ? String(value) : encodeURIComponent(String(value)),
                options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                options.path ? '; path=' + options.path : '',
                options.domain ? '; domain=' + options.domain : '',
                options.secure ? '; secure' : ''
            ].join(''));
        }

        // key and possibly options given, get cookie...
        options = value || {};
        var result, decode = options.raw ? function (s) { return s; } : decodeURIComponent;
        return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie)) ? decode(result[1]) : null;
    };

    /* check and uncheck */
    $.fn.extend({
        check: function () {
            return this.filter(":radio, :checkbox").attr("checked", true);
        },
        uncheck: function () {
            return this.filter(":radio, :checkbox").removeAttr("checked");
        }
    });

    /* inheritance */
    $.inherit = (function () {
        function intermediate() { }

        return function (child, parent) {
            intermediate.prototype = parent.prototype;
            child.prototype = new intermediate;
            child.prototype.constructor = child;
            child.superproto = parent.prototype;
            return child;
        };
    })();

    /* Dimension view builders */
    function baseDimBuilder(dimIndex, viewProductContext, sortBy, groupBy, onClickHandler, onChangeHandler) {
        this.$controlElem = null;
        this.data = null;
        this.itemClass = null;
        this.dimNameContainerClass = "DimensionTxt";
        this.dimInfo = $.extend({}, viewProductContext); // copy context
        this.options = viewProductContext.options;
        this.dimensionIndex = dimIndex;
        this.sortBy = sortBy;
        this.canChangeMainImage = false;
        this.groupBy = groupBy ? new Function('elem', groupBy) : function (dimElem) {
            return dimElem.val.replace(/[^0-9]/g, '');
        };
        this.onClickHandler = onClickHandler;
        this.onChangeHandler = onChangeHandler;
        // Workaround for the backward compatibility
        if (!viewProductContext.dimViewsInfo && viewProductContext.dimTypeMap) {
            // Old logic
            var oldStructureDimTypeMap = viewProductContext.dimTypeMap[this.dimensionIndex];
            if (oldStructureDimTypeMap != null) {
                this.dimInfo.dimTypeInfo = {
                    DimTypeId: oldStructureDimTypeMap.dimTypeId,
                    DimTypeName: oldStructureDimTypeMap.dimTypeName,
                    DimViewType: this.getControlViewType(),
                    SortBy: sortBy,
                    GroupBy: groupBy,
                    PositionInDimArray: dimIndex
                };
            }
        }
        else {
            this.dimInfo.dimTypeInfo = _.find(viewProductContext.dimViewsInfo, function (dimViewInfo) {
                return dimViewInfo.PositionInDimArray === dimIndex;
            });
        }

        this.dimControlId = 'dimControl_' + this.dimInfo.dimTypeInfo.DimTypeId + '_' + new Date().getTime();

        this.sessionStorageObject = new SessionStorageObject(this.getControlViewType());

        this.isNotyShown = false;

        this.init();
    }
    baseDimBuilder.prototype = (function () {
        // the prototype itself
        return {
            constructor: baseDimBuilder,
            getSelectedValue: function () {
                if (this.itemClass) {
                    var selectedElem = $('.' + this.itemClass + '.selected', this.$controlElem);
                    return selectedElem.length === 1 ? selectedElem.attr('data-dimId') : 0;
                }
                throw "getSelectedValue method is not implemented " + this.getControlViewType();
            },
            setSelectedValue: function (selValue, fireOnChangeEvent, isPreselect) {
                if (this.itemClass) {
                    if (!selValue) return;
                    var itemToSelect = $('.' + this.itemClass + '[data-dimId="' + selValue + '"]:not(.disabled' + (isPreselect ? ',.selected' : '') + ')', this.$controlElem);
                    if (itemToSelect.length === 1) {
                        // Clear previous selection
                        var prevSelected = $('.' + this.itemClass + '.selected', this.$controlElem);
                        prevSelected.removeClass('selected');
                        // Select current item if it is not the same as previous (for deselect emulating)
                        if (!prevSelected.is(itemToSelect)) {
                            itemToSelect.addClass('selected');
                        }

                        if (fireOnChangeEvent) {
                            this.handleEvent(this.onChangeHandler, this.getSelectedValue(), this);
                        }
                    }
                } else {
                    throw "setSelectedValue method is not implemented " + this.getControlViewType();
                }
            },
            getControlViewType: function () {
                return "baseDimBuilder";
            },
            getDimensionsCount: function (activeOnly) {
                if (this.itemClass) {
                    var selector = '.' + this.itemClass + (activeOnly ? ':not(.disabled)' : '');
                    return $(selector, this.$controlElem).length;
                }
                throw "getDimensionsCount method is not implemented " + this.getControlViewType();
            },
            filter: function (availableDimIdsArray) {
                var self = this;
                if (this.itemClass) {
                    $('.' + this.itemClass + '[data-dimId]', this.$controlElem).each(function () {
                        var $item = $(this);
                        var val = parseInt($item.attr('data-dimId'));
                        if (!val) return;
                        if (_.contains(availableDimIdsArray, val)) {
                            $item.toggleClass('disabled', false);
                            var baseTitle = self.sessionStorageObject.getValue(val + '_baseTitle');
                            if (baseTitle) {
                                $item[0].title = baseTitle;
                            }
                        } else {
                            $item.toggleClass('disabled', true);
                        }
                    });
                }
            },
            setShowOnly: function(showOnlyDict) {
                var self = this;
                if (this.itemClass) {
                    $('.' + this.itemClass + '[data-dimId]', this.$controlElem).each(function() {
                        var $item = $(this);
                        var val = parseInt($item.attr('data-dimId'));
                        if (!val) return;
                        if (val in showOnlyDict) {
                            var showOnlyReason = showOnlyDict[val].showOnlyReason;
                            if (showOnlyReason) {
                                var originalItemTitle = self.sessionStorageObject.getValue(val + '_baseTitle');
                                if (!originalItemTitle) {
                                    originalItemTitle = $item[0].title;
                                    self.sessionStorageObject.setValue(val + '_baseTitle', originalItemTitle);
                                }
                                $item[0].title = originalItemTitle + ' (' + showOnlyReason + ')';
                            }
                        }
                    });
                }
            },
            resetShowOnly: function () {
                var self = this;
                if (this.itemClass) {
                    $('.' + this.itemClass + '[data-dimId]', this.$controlElem).each(function () {
                        var $item = $(this);
                        var val = parseInt($item.attr('data-dimId'));
                        if (!val) return;

                        var originalDimName = self.sessionStorageObject.getValue(val + '_baseTitle');
                        if (originalDimName) {
                            $item[0].title = originalDimName;
                        }
                    });
                }
            },
            handleEvent: function (customHandler, args, ctx) {
                if (customHandler && $.isFunction(customHandler)) {
                    var eventArgs = [];
                    for (var i = 0; i < args.length; i++) {
                        eventArgs.push(args[i]);
                    }
                    if (!ctx) ctx = this;
                    customHandler.apply(ctx, [this, eventArgs]);
                }
            },
            _prepareData: function () {
                var dimInfo = this.dimInfo;
                if (dimInfo && !$.isEmptyObject(dimInfo)) {
                    // Prepare data for dimension control
                    var controlContext = this;
                    var data = {};
                    for (var prop in dimInfo.dimProds) {
                        if (dimInfo.dimProds.hasOwnProperty(prop)) {
                            var val = dimInfo.dimProds[prop];
                            var dimId = val.dims[controlContext.dimensionIndex];
                            var isSingleDimensionProd = val.dims.length === 1;
                            if (!data[dimId]) {
                                data[dimId] = { id: dimId, val: dimInfo.dimMap[dimId] };
                                if (isSingleDimensionProd) {
                                    data[dimId].price = val.price;
                                    data[dimId].qty = val.qty;
                                    data[dimId].isShowOnly = val.isShowOnly;
                                    data[dimId].showOnlyReason = val.showOnlyReason;
                                }
                            }
                        }
                    }

                    // Filter dimensions by url params (if exist). Incident#00060771
                    var urlDimensionsParam = $.trim($.getQueryStringParam(window.location.search, dimInfo.dimTypeInfo.DimTypeName));
                    if (urlDimensionsParam) {
                        var urlDims = urlDimensionsParam.split(',');
                        data = _.filter(data, function (dim) {
                            return _.contains(urlDims, dim.val);
                        });
                    }

                    if (!_.isEmpty(data)) {
                        // Sort if needed
                        controlContext.data = controlContext.sortBy ? _.sortBy(data, controlContext.sortBy == 'val' ? 'val' : new Function('elem', controlContext.sortBy)) : data;
                    }
                }
            },
            init: function () {
                throw "init method is not implemented in " + this.getControlViewType();
            },
            showDimIsNotSelectedTooltip: function () {
                var tooltipElem = $('.' + this.dimNameContainerClass, this.$controlElem);
                if (!tooltipElem.data('qtip')) {
                    // Initialize qtip
                    var tooltipOptions = {
                        content: {
                            text: this.options.selectDimMsg + ' <b>' + this.dimInfo.dimTypeInfo.DimTypeName + '</b>'
                        },
                        show: {
                            event: 'click',
                            effect: function () {
                                $(this).fadeIn(400);
                            }
                        },
                        hide: {
                            target: $('.' + this.itemClass, this.$controlElem),
                            event: 'click',
                            effect: function () {
                                $(this).fadeOut(400);
                            },
                            inactive: 3000
                        },
                        position: {
                            my: 'left bottom',
                            at: 'right center'
                        },
                        style: {
                            classes: 'DimensionIsNotSelectedTooltip'
                        }
                    };
                    tooltipElem.qtip(tooltipOptions);
                }

                // Show tooltip
                tooltipElem.qtip("show");
            },
            showDimIsNotSelectedNoty: function () {
                if (!this.isNotyShown) {
                    var self = this;
                    var notyContract = {
                        text: this.options.selectDimMsg + ' <b>' + this.dimInfo.dimTypeInfo.DimTypeName + '</b>',
                        callback: {
                            onClose: function() {
                                self.isNotyShown = false;
                            }
                        }
                    };
                    window.PubSub.publish('notification.warning', notyContract);
                    this.isNotyShown = true;
                }
            },
            hasSelectedRelatedDimensionImage: function() { return false; },
            changeMainImageToRelatedDimensionImage: function () {}
        };
    })();
    $.baseDimBuilder = baseDimBuilder;

    /* Custom fields */
    function customFieldsRenderer(customFieldsContainer, cssPrefix, customFields, defaultRequiredMessage, invalidFormatMessage) {
        var customFieldObjects = [];

        return {
            render: function() {
                if (customFieldsContainer && customFields && customFields.length > 0) {

                    var visibleCustomFields = customFields.filter(function (field) {
                        return field.isVisible;
                    });

                    $('.js-custom-field-container', customFieldsContainer).each(function () {
                        var $customFieldContainer = $(this);
                        if ($customFieldContainer && $customFieldContainer.data("display-type") === 'editable') {
                            var editableCustomFields = visibleCustomFields.filter(function (field) {
                                return field.displayType === 'editable';
                            });

                            if (editableCustomFields.length > 0) {
                                var id = $customFieldContainer.data("id");
                                if (id) {
                                    var customField = customFields.find(function (x) { return x.customFieldID === id; });
                                    if (customField) {
                                        var customFieldObject;
                                        var enablePlaceholder = $customFieldContainer.data("enable-placeholder");
                                        switch (customField.editorType) {
                                            case "int":
                                                customFieldObject = new wholeNumber(customField, $customFieldContainer, cssPrefix, enablePlaceholder, defaultRequiredMessage, invalidFormatMessage);
                                                customFieldObjects.push(customFieldObject);
                                                break;
                                            case "textstring":
                                                customFieldObject = new textString(customField, $customFieldContainer, cssPrefix, enablePlaceholder, defaultRequiredMessage, invalidFormatMessage);
                                                customFieldObjects.push(customFieldObject);
                                                break;
                                            case "checkbox":
                                                customFieldObject = new checkboxCustomField(customField, $customFieldContainer, cssPrefix, defaultRequiredMessage, invalidFormatMessage);
                                                customFieldObjects.push(customFieldObject);
                                                break;
                                            default:
                                                break;
                                        }

                                        if (customFieldObject)
                                            customFieldObject.render(customField, cssPrefix);
                                    }
                                }

                            }
                        }
                    });
                }
            },
            validate: function () {
                return customFieldObjects.every(function (customFieldObject) { return customFieldObject.validate()});
            }
        };
    }

    function customFieldBase(customField, container, cssPrefix, enablePlaceholder, defaultRequiredMessage, invalidFormatMessage) {
        this.customField = customField;
        this.container = container;
        this.cssPrefix = cssPrefix;
        this.defaultRequiredMessage = defaultRequiredMessage;
        this.invalidFormatMessage = invalidFormatMessage;
        this.customFieldMethods = customFieldHelper(customField, enablePlaceholder);
    }
    customFieldBase.prototype.render = function () {};
    customFieldBase.prototype.validate = function () { return true; };

    function customFieldTextInput(customField, container, cssPrefix, enablePlaceholder, defaultRequiredMessage, invalidFormatMessage) {
        customFieldBase.call(this, customField, container, cssPrefix, enablePlaceholder, defaultRequiredMessage, invalidFormatMessage);
        this.input = null;
    }

    customFieldTextInput.prototype = Object.create(customFieldBase.prototype);
    customFieldTextInput.prototype.render = function () {
        this.input = this.customFieldMethods.createInputControl(this.cssPrefix);
        if (this.input) {
            $(this.input).addClass('form-control');

            if (this.customField.isRequired) {
                $(this.input).attr('data-rule-required', 'true');
                if (this.customField.requiredRegex)
                    $(this.input).attr('data-rule-pattern', this.customField.requiredRegex);
                $(this.input).attr('data-msg-required',
                    this.customField.requiredErrorMessage
                        ? this.customField.requiredErrorMessage
                        : this.defaultRequiredMessage);
                if (this.customField.requiredRegex && this.invalidFormatMessage)
                    $(this.input).attr('data-msg-pattern', this.invalidFormatMessage);
            }
        }
        this.container.append(this.input);
    };
    customFieldTextInput.prototype.validate = function () {
        $(this.input).keypress(function () {
            validate(this);
        });

        function validate(input) {
            var result = $('form').validate().element(input);

            if (!result)
                $(input).parent().addClass('has-error');
            else
                $(input).parent().removeClass('has-error');

            return result;
        }
        return validate(this.input);
    };


    function wholeNumber(customField, container, cssPrefix, enablePlaceholder, defaultRequiredMessage, invalidFormatMessage) {
        customFieldTextInput.call(this, customField, container, cssPrefix, enablePlaceholder, defaultRequiredMessage, invalidFormatMessage);
    }

    wholeNumber.prototype = Object.create(customFieldBase.prototype);
    wholeNumber.prototype.render = function () {
        customFieldTextInput.prototype.render.call(this);
        if (this.input) {
            $(this.input).numeric(false);
            $(this.input).addClass('integer');
            if (!this.customField.requiredRegex)
                $(this.input).attr('data-rule-pattern', '\\d+');
        }
    };
    wholeNumber.prototype.validate = function () {
        if (!this.input)
            throw 'Whole number input control is not rendered!';

        return customFieldTextInput.prototype.validate.call(this);
    };

    function textString(customField, container, cssPrefix, enablePlaceholder, defaultRequiredMessage, invalidFormatMessage) {
        customFieldTextInput.call(this, customField, container, cssPrefix, enablePlaceholder, defaultRequiredMessage, invalidFormatMessage);
    }

    textString.prototype = Object.create(customFieldBase.prototype);
    textString.prototype.render = function () {
        customFieldTextInput.prototype.render.call(this);
    };
    textString.prototype.validate = function () {
        if (!this.input)
            throw 'Text string input control is not rendered!';

        return customFieldTextInput.prototype.validate.call(this);
    };

    function checkboxCustomField(customField, container, cssPrefix, defaultRequiredMessage, invalidFormatMessage) {
        customFieldBase.call(this, customField, container, cssPrefix, false, defaultRequiredMessage, invalidFormatMessage);
        this.input = null;
    }

    checkboxCustomField.prototype = Object.create(customFieldBase.prototype);
    checkboxCustomField.prototype.render = function () {
        this.input = this.customFieldMethods.createCheckboxControl(this.cssPrefix);
        if (this.input) {
            $(this.input).numeric(false);

            if (this.customField.isRequired) {
                $(this.input).attr('data-rule-required', 'true');

                $(this.input).attr('data-msg-required',
                    this.customField.requiredErrorMessage
                        ? this.customField.requiredErrorMessage
                        : this.defaultRequiredMessage);
            }
        }
        this.container.append(this.input);
    };

    function customFieldHelper(customField, enablePlaceholder) {
        var html = new htmlHelper();

        function isNullOrWhitespace(inputStr) {
            if (typeof inputStr === 'undefined' || inputStr === null) return true;
            return inputStr.replace(/\s/g, '').length < 1;
        }

        function getInternalCustomFieldId(cssPrefix, customField) {
            return !isNullOrWhitespace(customField.alias) ? cssPrefix + '_cf_' + customField.alias + '_' + customField.customFieldID : cssPrefix + '_cf_' + customField.customFieldID;
        }

        return {
            createInputControl: function(cssPrefix) {
                var id = getInternalCustomFieldId(cssPrefix, customField);
                var attributes = { "data-customfieldid": customField.customFieldID };
                var defaultCustomFieldCssClass = "js-custom-field";

                var inputStyleString = '';
                if (customField.heightInPx > 0)
                    inputStyleString += 'height:' + customField.heightInPx + 'px;';

                if (customField.widthInPx > 0)
                    inputStyleString += 'width:' + customField.widthInPx + 'px;';

                if (inputStyleString !== '')
                    attributes["style"] = inputStyleString;

                if (customField.maxLength > 0)
                    attributes["maxlength"] = customField.maxLength;

                if (enablePlaceholder)
                    attributes["placeholder"] = customField.label;

                attributes["autocomplete"] = "off";

                var inputControl = html.input(id, "text", defaultCustomFieldCssClass, customField.guiFriendlyValue, attributes);
                return inputControl;
            },
            createCheckboxControl: function(cssPrefix) {
                var id = getInternalCustomFieldId(cssPrefix, customField);
                var attributes = { "data-customfieldid": customField.customFieldID };
                var defaultCustomFieldCssClass = "js-custom-field";

                var inputStyleString = '';
                if (customField.heightInPx > 0)
                    inputStyleString += 'height:' + customField.heightInPx + 'px;';

                if (customField.widthInPx > 0)
                    inputStyleString += 'width:' + customField.widthInPx + 'px;';

                if (inputStyleString !== '')
                    attributes["style"] = inputStyleString;

                var initialValue = customField.isRequired || customField.value.ValueBit === true;
                if (initialValue)
                    attributes['checked'] = 'checked';

                if (customField.isRequired)
                    attributes['disabled'] = 'disabled';

                var inputControl = html.input(id, "checkbox", defaultCustomFieldCssClass, initialValue, attributes);
                return inputControl;
            }
        };
    }

    function htmlHelper() {
        return {
            input: function(id, type, classes, value, attributes) {
                var input = document.createElement('input');
                $(input).attr('id', id);
                $(input).attr('type', type);
                $(input).attr('class', classes);
                $(input).attr(attributes);
                $(input).val(value);
                return input;
            }
        };
    }

    $.customFieldsRenderer = customFieldsRenderer;

    /* jQuery deparam function to convert parameterized (querystring) to object. */
    $.deparam = function (params, coerce) {
        var obj = {},
            coerce_types = { 'true': !0, 'false': !1, 'null': null };

        // Iterate over all name=value pairs.
        $.each(params.replace(/\+/g, ' ').split('&'), function (j, v) {
            var param = v.split('='),
                key = decodeURIComponent(param[0]),
                val,
                cur = obj,
                i = 0,
                // If key is more complex than 'foo', like 'a[]' or 'a[b][c]', split it
                // into its component parts.
                keys = key.split(']['),
                keys_last = keys.length - 1;

            // If the first keys part contains [ and the last ends with ], then []
            // are correctly balanced.
            if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
                // Remove the trailing ] from the last keys part.
                keys[keys_last] = keys[keys_last].replace(/\]$/, '');

                // Split first keys part into two parts on the [ and add them back onto
                // the beginning of the keys array.
                keys = keys.shift().split('[').concat(keys);

                keys_last = keys.length - 1;
            } else {
                // Basic 'foo' style key.
                keys_last = 0;
            }

            // Are we dealing with a name=value pair, or just a name?
            if (param.length === 2) {
                val = decodeURIComponent(param[1]);

                // Coerce values.
                if (coerce) {
                    val = val && !isNaN(val) ? +val              // number
                        : val === 'undefined' ? undefined         // undefined
                            : coerce_types[val] !== undefined ? coerce_types[val] // true, false, null
                                : val; // string
                }

                if (keys_last) {
                    // Complex key, build deep object structure based on a few rules:
                    // * The 'cur' pointer starts at the object top-level.
                    // * [] = array push (n is set to array length), [n] = array if n is
                    //   numeric, otherwise object.
                    // * If at the last keys part, set the value.
                    // * For each keys part, if the current level is undefined create an
                    //   object or array based on the type of the next keys part.
                    // * Move the 'cur' pointer to the next level.
                    // * Rinse & repeat.
                    for (; i <= keys_last; i++) {
                        key = keys[i] === '' ? cur.length : keys[i];
                        cur = cur[key] = i < keys_last
                            ? cur[key] || (keys[i + 1] && isNaN(keys[i + 1]) ? {} : [])
                            : val;
                    }

                } else {
                    // Simple key, even simpler rules, since only scalars and shallow
                    // arrays are allowed.

                    if ($.isArray(obj[key])) {
                        // val is already an array, so push on the next value.
                        obj[key].push(val);

                    } else if (obj[key] !== undefined) {
                        // val isn't an array, but since a second value has been specified,
                        // convert val into an array.
                        obj[key] = [obj[key], val];

                    } else {
                        // val is a scalar.
                        obj[key] = val;
                    }
                }

            } else if (key) {
                // No value was defined, so set something meaningful.
                obj[key] = coerce
                    ? undefined
                    : '';
            }
        });

        return obj;
    };

    /* Buy feedback popup */
    var $buyFeedbackCont = null;
    $.showBuyFeedbackPopup = function (popupTemplate, feedbackData) {
        // Populate template
        var popupHtml = _.template(popupTemplate, feedbackData);

        var $popupDialog = $(popupHtml).dialog({
            autoOpen: true,
            modal: true,
            resizable: false,
            title: feedbackData.labels.additionalText,
            width: '640px',
            dialogClass: 'popup-after-buy',
            draggable: true,
            appendTo: 'body',
            close: function() {
                $popupDialog.dialog('destroy').remove();
                $buyFeedbackCont = null;
                window.PublicEStore.unsubscribe(removeSubscriptionToken);
                window.PublicEStore.unsubscribe(emptySubscriptionToken);
                window.PublicEStore.unsubscribe(addSubscriptionToken);
            },
            open: function(event, ui){
                var thisOne = $(this);
                var wholePopUp = thisOne.closest('.ui-dialog');
                thisOne.find('.js-PopUpContinue').bind('click', function(){
                    thisOne.dialog('close');
                });
                wholePopUp.next('.ui-widget-overlay').bind('click',function(){
                    thisOne.dialog('close');
                });
            }
        });

        $buyFeedbackCont = $('#orderProductSummary');

        // Setup popup area
        $buyFeedbackCont.find('.BuyBtn').click(function (evt) {
            evt.stopPropagation();

            var $prodCont = $(this).closest('.js-bfp-rel-item');
            var addToCartContract = {
                productId: $prodCont.data('productid'),
                quantity: $prodCont.find('.QuantityTxb,.QuantityDrp').val()
            };

            function addToCartCallback(dataContract) {
                _.each(dataContract.result.items,
                    function(prod) {
                        if (prod.status.toLowerCase() !== 'ok') {
                            window.PubSub.publish('notification.error', prod.message);
                        }
                    });
            }

            $.when(window.PublicEStore.addToCart([addToCartContract])).then(addToCartCallback, ajaxFailHandler);
        });

        function updateOrderTotals(infoContract) {
            $buyFeedbackCont.find('.js-total-prod-count').text(infoContract.productCount);
            $buyFeedbackCont.find('.js-total-price').text(infoContract.totalPrice.toMoney());
        }

        function getAndUpdateOrderTotals() {
            $.when(window.PublicEStore.getCartInfo(null, true)).then(function(cartInfoContract) {
                    updateOrderTotals(cartInfoContract.result.cartInfo);
                },
                ajaxFailHandler);
        }

        var $relProdsCont = $buyFeedbackCont.find('.js-bfp-rel-item');

        function removeFromCartCallback(topic, dataContract) {
            _.each(dataContract.result.items, function (prod) {
                if (prod.status.toLowerCase() === 'ok') {
                    $relProdsCont.filter('[data-productid="' + prod.productID + '"]').find('.js-add-to-cart').hide();
                }
            });
            getAndUpdateOrderTotals();
        }

        function emptyCartCallback(topic, dataContract) {
            if (dataContract.status.toLowerCase() === 'ok') {
                $relProdsCont.find('.js-add-to-cart').hide();
            }
            getAndUpdateOrderTotals();
        }

        function addToCartEventCallback(topic, contract) {
            updateOrderTotals(contract.result.detailedCartInfo.summary);
            _.each(contract.result.items, function (prod) {
                if (prod.status.toLowerCase() === 'ok') {
                    // Update total product's count for the current temp order line
                    var prodContainer = $relProdsCont.filter('[data-productId="' + prod.productID + '"]');
                    var orderLineQuantityContainer = prodContainer.find('.js-prod-count');
                    orderLineQuantityContainer.show();
                    orderLineQuantityContainer.text(prod.totalQuantityInTempOrderLine);

                    // Animate action
                    var addToCartIconContainer = prodContainer.find('.js-add-to-cart');
                    if (addToCartIconContainer.length > 0) {
                        addToCartIconContainer.show();
                        prodContainer.effect('transfer', { to: addToCartIconContainer }, 500, function () {
                            addToCartIconContainer.effect('bounce', null, 500);
                        });
                    }
                }
            });
        }

        var removeSubscriptionToken = window.PublicEStore.subscribe('estore.callback.shopcart.removefromcart', removeFromCartCallback);
        var emptySubscriptionToken = window.PublicEStore.subscribe('estore.callback.shopcart.emptycart', emptyCartCallback);
        var addSubscriptionToken = window.PublicEStore.subscribe('estore.callback.shopcart.addtocart', addToCartEventCallback);
    };

    /* Quantity discounts */
    $.loadListQuantityDiscounts = function () {
        function getProductLists() {
            var lists = [];

            //Add 162 and 167
            $('div.UC162, div.UC167').each(function () {
                var list = $(this);
                list.controlId = parseInt(list.attr('id').replace('UC', ''));
                list.items = [];

                $('div.ProdItemContainer', list).each(function () {
                    var item = $(this);
                    item.itemId = parseInt($('input[type="hidden"]', item).first().val());
                    item.image = $('img.Image', item);
                    item.priceText = $('span.PriceTxt', item);
                    item.price = $('span.Price', item);
                    item.original = $('span.OriginalPrice', item);
                    item.discount = $('span.DiscountPrice', item);

                    list.items.push(item);
                });

                lists.push(list);
            });

            //Add 101
            $('table.UC101MainContainer').each(function () {
                var list = $(this);
                list.controlId = parseInt($('td.ListContainer > table', list).first().attr('id').replace('UC', ''));
                list.items = [];

                $('td.ProdItemContainer, td.ProdItemContainerAlt', list).each(function () {
                    var item = $(this);
                    item.image = $('img.Image', item);
                    item.itemId = parseInt(item.image.attr('id').replace('img', ''));
                    item.priceText = $('span.PriceTxt', item);
                    item.price = $('span.Price span', item);
                    item.original = $('span.OriginalPrice span', item);
                    item.discount = $('span.DiscountPrice span', item);

                    list.items.push(item);
                });

                lists.push(list);
            });

            //Add 130
            $('table.UC130MainContainer').each(function () {
                var list = $(this);
                list.controlId = parseInt(list.attr('id').replace('UC', ''));
                list.items = [];

                $('td.ProdItemContainer, td.ProdItemContainerAlt', list).each(function () {
                    var item = $(this);
                    item.image = $('img.Image', item);
                    item.itemId = parseInt(item.image.attr('id').replace('img', ''));
                    item.priceText = $('span.PriceTxt', item);
                    item.price = $('span.Price span', item);
                    item.original = $('span.OriginalPrice span', item);
                    item.discount = $('span.DiscountPrice span', item);

                    list.items.push(item);
                });

                lists.push(list);
            });

            return lists;
        };

        //Get product lists on the page
        var productLists = getProductLists();

        //Build a list of itemid's
        var itemIds = [];
        _.each(productLists, function (v) {
            itemIds = _.union(itemIds, _.pluck(v.items, 'itemId'));
        });

        if (!itemIds || itemIds.length === 0) {
            return;
        }

        $.publicFetch({
            handler: "EStoreData",
            data: { a: 'CountQuantityDiscountsMulti', itemIds: itemIds.join(',') },
            success: function (data) {
                if (!data || data.length === 0) {
                    return;
                }

                _.each(productLists, function (list) {
                    _.each(list.items, function (item) {
                        var qtyItem = _.find(data, function (val) { return val.itemId === item.itemId; });
                        if (qtyItem && qtyItem.count > 0) {
                            item.image.parent().prepend('<em class="QuantityDiscount Count' + qtyItem.count + '"/>');
                        }
                    });
                });
            }
        });
    };

    /* Locale cookies */
    $.setLocaleCookie = function (locale) {
        $.cookie('PreferredLocale', locale, { expires: 365, path: window.R });
        window.PubSub.publish('cookie.local-cookie-set', locale);
    };

    /* Currency cookies */
    $.setCurrencyCookie = function (currency) {
        $.cookie('PreferredCurrency', currency, { expires: 365, path: window.R });
        window.PubSub.publish('cookie.currency-cookie-set', currency);
    };
    $.getCurrencyCookie = function () {
        return $.cookie('PreferredCurrency');
    };

    /* Query string getter and setter */
    $.setQueryStringParam = function (uri, key, value) {
        var re = new RegExp("([?|&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            return uri + separator + key + "=" + value;
        }
    };
    $.getQueryStringParam = function (uri, key) {
        var regExp = new RegExp('[\\?&]' + key + '=([^&#]*)', 'i');
        var decoded;

        try {
            decoded = decodeURIComponent(uri);
        } catch (err) {
            console.error(err);
            return '';
        }

        var val = regExp.exec(decoded);
        return val ? decodeURIComponent(val[1].replace(/\+/g, ' ')) : '';
    };
    $.removeQueryStringParam = function (uri, key) {
        var urlparts = uri.split('?');
        if (urlparts.length >= 2) {
            var prefix = encodeURIComponent(key) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            // reverse iteration as may be destructive
            for (var i = pars.length; i-- > 0;) {
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            uri = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
            return uri;
        } else {
            return uri;
        }
    }
    $.getUrlParamsObj = function (uri) {
        var search = uri.substring(1);
        return search
            ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === '' ? value : decodeURIComponent(value) })
            : {};
    };

    /* Scroll to element */
    $.fn.scrollToThis = function (time, verticalOffset) {
        time = typeof (time) != 'undefined' ? time : 800;
        verticalOffset = typeof (verticalOffset) != 'undefined' ? verticalOffset : 0;
        var element = $(this);
        var offset = element.offset();
        var offsetTop = offset.top + verticalOffset;
        $('html, body').stop().animate({
            scrollTop: offsetTop
        }, time);
    };

    /* To currency formatter */
    window.toCurrency = function (prices, currencyCode) {
        prices = _.isArray(prices) ? prices : [prices];
        // If prices are passed as strings, ensure the decimal separator will be '.' and not ','
        var processedPrices = _.map(prices, function (price) {
            if (typeof (price) === 'string') {
                return price.replace(',', '.');
            } else {
                return price;
            }
        });

        var params = { prices: JSON.stringify(processedPrices) };
        if (currencyCode) {
            params.currency = currencyCode;
        }

        return $.get(window.R + 'handlers/public/currencyformatter.ashx', params);
    }

    //#endregion Jquery extensions

    //#region Global functions
    /* Set equal heights */
    window.SetEqualHeights = function () {
        //Define context (Controls)
        var context = $(".UC101MainContainer, .UC132MainContainer, .UC130MainContainer, .UC134MainContainer, .UC120MainContainer, .UC111MainContainer, .UC137MainContainer, .UC124MainContainer, .UC162, .UC167, .ListDocuments");

        //Declare row containers
        var cont = context.find(".ListContainer > table > tbody > tr, .SubListContainer > table > tbody > tr, .DataItemsRow, .SliderDataItemsRow, .SliderContainer").not('.DisableAutoHeight');

        //Declare column containers, innermost containers first!
        var cols = new Array(".ItemTitleCont", ".Teaser", ".Content", ".ItemTitleContainer", '.PriceContainer', ".TitleAndTeaserContainer", '.ProductNumberCont', ".TeaserContainer", ".DescriptionContainer", ".ProdDetailsContainer", ".ContentContainer", ".RatingContainer", '.MakeOrderContainer', '.PricesContainer', '.PriceAndBuy', '.DetailsContainer', '.OuterDetailsCont', '.ItemContainer');
        //For each row container
        cont.each(function () {
            //For each columns container
            for (var x = 0; x < cols.length; x++) {
                //Declare items, a new array for heights and an index counter
                var items = $(this).find(cols[x]), its = new Array(), cr = 0;

                items.css('height', 'auto');

                //Check item count
                if (items.length > 1) {
                    //Get all heights
                    items.each(function () {
                        var invisibleParents;

                        if ($(this).is(':hidden')) {
                            // Unhide all invisible parent nodes for a moment in order to calculate element's height
                            invisibleParents = $(this).parents().filter(function () { return $(this).css("display") == "none"; }).css('visibility', 'hidden').show();
                        }

                        its[cr++] = $(this).innerHeight();

                        if (invisibleParents)
                            invisibleParents.css('visibility', 'visible').hide();
                    });

                    //Set heights to max
                    items.css('height', Math.max.apply(Math, its) + 'px');
                }
            }
        });
    }

    /* Local storage */
    window.saveToLocalStorage = function(key, value) {
        if (key && ('localStorage' in window) && window['localStorage'] !== null) {
            window.localStorage.setItem(key, value);
        }
    };
    window.getFromLocalStorage = function(key) {
        return ('localStorage' in window) && window['localStorage'] !== null ? window.localStorage.getItem(key) : null;
    };
    window.removeFromLocalStorage = function(key) {
        if (('localStorage' in window) && window['localStorage'] !== null) {
            window.localStorage.removeItem(key);
        }
    };
    window.getAllFromLocalStorage = function() {
        var keys = [];

        for (var i = 0, len = localStorage.length; i < len; ++i) {
            keys.push(localStorage.key(i));
        }

        return keys;
    };
    window.getAllByPrefixFromLocalStorage = function(prefix) {
        var prefixedKeys = [];

        if (!prefix) {return prefixedKeys};

        for (var i = 0, len = localStorage.length; i < len; ++i) {
            var key = localStorage.key(i);

            if (key && key.indexOf(prefix) === 0) {
                prefixedKeys.push(key);
            }
        }

        return prefixedKeys;
    };
    window.removeByPrefixFromLocalStorage = function(prefix) {
        var prefixedKeys = window.getAllByPrefixFromLocalStorage(prefix);
        prefixedKeys.forEach(function(key) {
            window.removeFromLocalStorage(key);
        });
    };

    /* Popups */
    window.popup = function (options) {
        var onClose = function () {
            var $this = $(this);

            if (options.canBeClosedByUser) {
                var $popup = $this.find('.js-popup');
                if (!$popup || !$popup.length) {
                    $popup = $this[0].$message.find('.js-popup');
                }

                var popupId = $popup.data('popupid');

                var $dontShowCheckbox = $popup.find('.js-dont-show-popup');
                var dontShowExplicit = $dontShowCheckbox.length > 0 && $dontShowCheckbox.is(':checked');

                $.ajax({
                        url: window.R + 'handlers/public/userdata.ashx',
                        type: 'POST',
                        data: {
                            action: 'StorePopupDisplaySettings',
                            popupId: popupId,
                            dontShowExplicit: dontShowExplicit
                        },
                        dataType: 'json',
                    })
                    .done(function() {
                        console.log('Popup \'' +
                            popupId +
                            '\' display registered' +
                            (dontShowExplicit ? ' (don\'t show any more based on user selection)' : ''));
                    });
            }

            if (options.type === 'ModalBox') {
                $this.dialog('destroy').remove(); // https://stackoverflow.com/questions/4740500/jquery-dialog-dialog-fields-added-multiple-times-to-the-dom
            }
        };

        var fnOpenPopup;
        switch (options.type) {
            case 'ModalBox':
                fnOpenPopup = (function () {
                    var dialogOptions = {
                        title: options.title,
                        resizable: false,
                        draggable: false,
                        modal: true,
                        autoOpen: true,
                        width: options.width || 700,
                        close: onClose,
                        // For jQueryUI >= 1.12
                        classes: {
                            'ui-dialog': ['umw-popup-modal', options.classes].join(' '),
                            'ui-dialog-titlebar': 'umw-popup-modal-titlebar',
                            'ui-dialog-title': 'umw-popup-modal-title',
                            'ui-dialog-titlebar-close': 'umw-popup-modal-close',
                            'ui-dialog-content': 'umw-popup-modal-body'
                        },
                        // For jQueryUI < 1.12
                        dialogClass: ['umw-popup-modal', options.classes].join(' ')
                    };

                    if (!options.canBeClosedByUser) {
                        dialogOptions.closeOnEscape = false;
                        dialogOptions.open = function(event, ui) {
                            $('.ui-dialog-titlebar-close', ui.dialog | ui).hide();
                        };
                    }

                    $(options.content).dialog(dialogOptions);
                    reportPopupShown();
                });
                break;
            case 'Notification':
                fnOpenPopup = (function () {
                    // https://ned.im/noty/v2/options.html
                    var notyOptions = {
                        layout: 'bottomRight',
                        type: 'notification',
                        force: true,
                        closeWith: options.canBeClosedByUser ? ['button'] : [],
                        text: options.content,
                        template: '<div class="noty_message"><h3 class="noty_title"></h3><span class="noty_text"></span><div class="noty_close"></div></div>',
                        callback: {
                            onShow: function () {
                                if (options.title) {
                                    this.$bar.find('.noty_title').text(options.title);
                                }

                                this.$bar.addClass(['umw-popup-noty', options.classes].join(' '));
                            },
                            onClose: onClose
                        }
                    };

                    window.noty(notyOptions);
                    reportPopupShown();
                });
                break;
            default:
                return;
        }

        if (options.delay)
            window.setTimeout(fnOpenPopup, options.delay);
        else
            fnOpenPopup();

        function reportPopupShown() {
            window.PubSub.publish('popup.shown', { popupId: options.popupId });
        }
    };

    //#endregion Global functions

    var setupTooltips = function () {
        $('.Tooltip').tooltip();
    };

    var setupFancyboxes = function () {
        if (typeof $.fancybox === 'object' && $.fancybox !== null) {
            if (window.globalSettings.language === 3) {
                $.fancybox.defaults.i18n['no'] = {
                    CLOSE: 'Lukk',
                    NEXT: 'Neste',
                    PREV: 'Siste',
                    ERROR: 'Det forespurte innholdet kan ikke lastes. <br/>Vennligst prøv igjen senere.',
                    PLAY_START: 'Start bildefremvisning',
                    PLAY_STOP: 'Pause bildefremvisning',
                    FULL_SCREEN: 'Fullskjerm',
                    THUMBS: 'Miniatyrbilder',
                    DOWNLOAD: 'Last ned',
                    SHARE: 'Del',
                    ZOOM: 'Zoom'
                };

                $.fancybox.defaults.lang = 'no';
            }

            // Initialize fancybox for old controls
            $().fancybox({
                selector: "a[rel^='lightbox'], a[rel^='fancybox']",
                loop: true,
                buttons: [
                    'slideShow',
                    'close'
                ],
                caption: function() {
                    var $elem = $(this);
                    var caption = ($elem.data('caption') || $elem.attr('data-fancybox-description') || $elem.attr('fancyboxtext') || $elem.attr('title') || $elem.attr('alt') || '').trim();
                    return caption;
                }
            });
        }
    };

    var setupDateTimeSelectors = function () {
        //Setup date selectors
        if ($.datepicker) {
            $('input.dateselector').datepicker({ onClose: function () { $(this).blur(); } });
        }

        //Setup date and time selectors
        if ($.fn.datetimepicker) {
            $('input.datetimeselector').datetimepicker({ onClose: function () { $(this).blur(); } });
        }
    };

    var setupSearchControls = function () {
        var onSearchKeyPress = function (e) {
            if (e.which === 13) {
                e.preventDefault();
                var term = $.trim($(this).val());
                if (term) {
                    window.location = window.searchUrl + encodeURIComponent(term);
                }
            }
        };

        $('.smartsearch').autocomplete({
            minLength: 3,
            source: function (request, response) {
                var term = request.term;
                $.get(window.R + 'handlers/public/productdata.ashx', {
                    action: 'search',
                    term: term
                })
                    .done(function (searchResults) {
                        var items;
                        if (searchResults && searchResults.length > 0) {
                            items = _.map(searchResults, function (current) {
                                return {
                                    'label': current.Title + ' (' + current.ProductNo1 + ')',
                                    'value': current.ProductUrl
                                };
                            });
                        } else {
                            var noItemsMsg = window.globalSettings.language === 3 ? 'Ingen elementer' : 'No items';
                            items = [{ 'label': noItemsMsg, 'value': '#' }];
                        }

                        response(items);
                    })
                    .fail(ajaxFailHandler);
            },
            focus: function (evt) {
                evt.preventDefault();
            },
            select: function (evt, ui) {
                evt.preventDefault();

                if (ui.item.value !== '#') {
                    window.location = ui.item.value;
                }
            }
        }).on('keypress', onSearchKeyPress);
    };

    var setupNumericLimiters = function () {
        if ($.fn.numeric) {
            $('input.integer').numeric(false);
            $('input.decimal').numeric({ decimal: ',' });
        }
    };

    var setupValidation = function () {
        $.validator.addMethod("pattern", function (value, element, param) {
            if (!param.test) {
                param = new RegExp(param);
            }
            return this.optional(element) || param.test(value);
        }, "Invalid format.");

        var ignore = ":hidden";

        var val = $("form").validate({
            onsubmit: false,
            ignore: ignore
        });

        $('button[data-validates], input[type="submit"][data-validates]').click(function (e) {
            if (!itemsValid($('#' + $(e.currentTarget).data('validates')).find(':input').not(ignore))) {
                e.preventDefault();
            }
        });

        $('button[data-validation-group], input[type="submit"][data-validation-group]').click(function (e) {
            var group = $(e.currentTarget).data('validation-group');
            if (!itemsValid($(':input[data-validation-group="' + group + '"]').not(ignore))) {
                e.preventDefault();
            }
        });

        function itemsValid(items) {
            val.resetForm();

            var isValid = true;

            items.each(function (i, item) {
                if (!$(item).valid())
                    isValid = false;
            });

            return isValid;
        }
    };

    var setupNotifications = function () {
        var pubSub = window.PubSub;
        var showNotification = function (topic, contract) {
            var topicParts = topic.split('.');
            var notificationType = topicParts.length > 1 ? topicParts[topicParts.length - 1] : 'information';

            var defaultOptions = {
                layout: 'topCenter',
                type: notificationType,
                maxVisible: 15,
                force: true,
                timeout: 5000
            };

            var notyCallback = typeof (contract) === 'object' && contract && contract.notyCallback && typeof (contract.notyCallback) === 'function' ? contract.notyCallback : null;

            var notyOptions = typeof (contract) === 'object' && contract ? $.extend(true, defaultOptions, contract) : $.extend(defaultOptions, { text: contract });

            if (root.siteScripts) {
                notyOptions = root.siteScripts.converters.apply('NotyOptionsConverters', notyOptions);
            }

            var notyMsg = window.noty(notyOptions);

            if (notyCallback) {
                notyCallback(notyMsg);
            }
        }

        if (pubSub) {
            // Listen to the messages on global notifications channel
            pubSub.subscribe('notification', showNotification);

            if (window.notifyMessages) {
                _.each(window.notifyMessages, function (message) {
                    pubSub.publish('notification', message);
                });
            }
        }
    };

    var setupOrderConditionWarningNotifications = function () {
        if (window.PublicEStore) {
            window.PublicEStore.subscribe('estore.callback.shopcart.addtocart', function (topic, contract) {
                try {
                    if (typeof contract === 'object' && contract && contract.result) {
                        for (var i = 0; i < contract.result.items.length; i++) {
                            var item = contract.result.items[i];
                            if (item.orderConditionWarnings && item.orderConditionWarnings.length) {
                                window.PubSub.publish('notification.warning', item.orderConditionWarnings.join('<br>'));
                            }
                        }
                    }
                } catch (err) {
                    console.error(err);
                }

            });
        }
    };

    var setupProductsColoring = function () {
        if (window.globalSettings.showShoppingHistory) {
            var fetchShoppingHistory = function () {
                var successCallback = function (shoppingHistoryDataContract) {
                    var shoppingHistory = shoppingHistoryDataContract.result;

                    $('.ProdItemContainer, .ProdItem, .SearchItemContainer').each(function () {
                        var $currentProductContainer = $(this);
                        var currentItemId = parseInt($currentProductContainer.data('itemid'));
                        if (currentItemId > 0) {
                            var isProductInCart = _.contains(shoppingHistory.inCart, currentItemId);
                            $currentProductContainer.toggleClass('in-cart', isProductInCart);

                            var isProductInShoppingList = _.contains(shoppingHistory.inShoppingLists, currentItemId);
                            $currentProductContainer.toggleClass('in-shoppinglist', isProductInShoppingList);

                            var isProductInOrders = _.contains(shoppingHistory.inOrders, currentItemId);
                            $currentProductContainer.toggleClass('in-order', isProductInOrders);
                        }
                    });
                }

                var failCallback = function (errorContract) {
                    console.error('Shopping history: Failed to fetch customer shopping history from server: %s', errorContract.message);
                };

                $.when(window.PublicEStore.getCustomerShoppingHistory()).then(successCallback, failCallback);
            };

            var shoppingHistoryChanged = function (topic) {
                var interestedActions = ['addtocart', 'removefromcart', 'emptycart', 'addtoshoppinglist', 'removefromshoppinglist', 'addtowishlist', 'removefromwishlist'];
                var topicParts = (topic || '').split('.');
                if (topicParts.length > 0) {
                    var action = topicParts[topicParts.length - 1].toLowerCase();
                    if (_.contains(interestedActions, action)) {
                        // Re-fetch history
                        fetchShoppingHistory();
                    }
                } else {
                    console.error('Shopping history: Failed to parse estore action channel');
                }
            };

            fetchShoppingHistory();
            // Listen to estore changes
            window.PublicEStore.subscribe('estore.callback', shoppingHistoryChanged);
            // Listen to force re-color
            window.PubSub.subscribe('frontend.productlist.refresh', fetchShoppingHistory);
        }
    };

    var processBuyFeedbackPopup = function () {
        if (window.globalSettings.showBuyFeedbackPopup) {
            // Check if the product was bought on the server-side (not through the MPEF)
            var buyFeedbackContext = window.buyFeedbackContext;
            if (!$.isEmptyObject(buyFeedbackContext) && buyFeedbackContext.tempOrderLineId && !$buyFeedbackCont) {
                window.PublicEStore.getBuyFeedbackData(buyFeedbackContext);
            }

            // Subscribe to addtocart events and show buy feedback popup
            window.PublicEStore.subscribe('estore.callback.shopcart.addtocart', function (topic, contract) {
                if (!$buyFeedbackCont) {
                    var addedItems = [];
                    if (contract && contract.result && contract.result.items && contract.result.items.length > 0) {
                        addedItems = contract.result.items
                            .filter(function(item) {
                                return item.status.toLowerCase() === 'ok' && item.isUpdate === false;
                            })
                            .map(function(item) {
                                return { tempOrderLineId: item.tempOrderLineID, itemId: item.itemID };
                            });
                    }

                    if (addedItems.length > 0) {
                        window.PublicEStore.getBuyFeedbackData(addedItems);
                    }
                }
            });

            window.PublicEStore.subscribe('estore.callback.shopcart.getbuyfeedbackdata', function (topic, contract) {
                if (typeof contract === 'object' && contract && contract.result) {
                    $.showBuyFeedbackPopup(contract.result.popupTemplate, contract.result.popupData);
                }
            });
        }
    };

    var isFreeShippingPopupCanBeShown = function() {
        var lastPopupTime = window.getFromLocalStorage("LastFreeShipingPopupTime");
        var now = new Date().getTime();

        if (!lastPopupTime || ((now - lastPopupTime) / 1000) > 30) { // check in seconds
            window.saveToLocalStorage("LastFreeShipingPopupTime", now);
            return true;
        }

        return false;
    };

    var processFreeShipingOfferPopup = function() {
        // Subscribe to addtocart events and show free shipping offer popup
        if (window.globalSettings.showFreeShipingOfferPopup) {
            window.PublicEStore.subscribe('estore.callback.shopcart.addtocart',
                function(topic, contract) {
                    var $freeShipingOfferPopupTemplate = $('.js-FreeShipingPopupContainer').html();
                    if (!$freeShipingOfferPopupTemplate) {
                        $freeShipingOfferPopupTemplate = '<div><span>{%= description %}</span></div>';
                    }
                    $.ajax({
                            url: window.R + 'handlers/public/estoredata.ashx',
                            type: 'GET',
                            data: {
                                action: 'GetFreeShippingPopupDetails',
                                amount: contract.result.totalPrice
                            },
                            dataType: 'json'
                        })
                        .done(function(details) {
                            if (details.showPopup && isFreeShippingPopupCanBeShown()) {
                                details.freeShipingDelta = Math.round(details.freeShipingDelta * 100) / 100;
                                var templateSettings = {
                                    interpolate: /\{%=(.+?)%\}/g,
                                    escape: /\{%-(.+?)%\}/g,
                                    evaluate: /\{%(.+?)%\}/g
                                };
                                var popupHtml =
                                    _.template($freeShipingOfferPopupTemplate, details, templateSettings);
                                var popupDialog = $(popupHtml).dialog({
                                    modal: true,
                                    resizable: false,
                                    title: details.title,
                                    width: 500,
                                    dialogClass: 'free-shipping-popup',
                                    appendTo: 'form',
                                    close: function() {
                                        popupDialog.dialog('destroy').remove();
                                    }
                                });
                            }
                        })
                        .fail(ajaxFailHandler);
                });
        }
    };

    var processFreeShippingMessage = function () {
        var $progressCont = $('.js-free-shipping-progress-bar');
        var $progressLine = $('.js-free-shipping-progress-bar-line');
        var $messageCont = $('.js-free-shipping-message');

        var settings = window.globalSettings.freeShippingMessageSettings;

        if (settings && ($progressCont.length || $progressLine.length || $messageCont.length)) {
            window.PublicEStore.subscribe('estore.callback.shopcart', function(topic, contract) { updateValues(contract.result ? contract.result.totalPrice : 0); });
            updateValues(0);
        }

        function updateValues(amount) {
            $.ajax({
                    url: window.R + 'handlers/public/estoredata.ashx',
                    type: 'GET',
                    data: {
                        action: 'GetFreeShippingStatus',
                        amount: amount
                    },
                    dataType: 'json'
                })
                .done(function (result) {
                    try {
                        if (result && result.showNotification) {
                            if ($messageCont.length) {
                                var freeShippingMessage;
                                if (result.freeShippingRemainder > 0) {
                                    freeShippingMessage =
                                        settings.freeShippingMessage.replace('{0}', result.freeShippingRemainderStr);
                                } else {
                                    freeShippingMessage = settings.freeShippingReacedMessage;
                                }
                                $messageCont.html(freeShippingMessage);
                                $messageCont.show();
                            }
                            $progressLine.attr('aria-valuenow', result.progress * 100);
                            $progressLine.css('width', result.progress * 100 + '%');
                            $progressCont.show();
                        } else {
                            $progressCont.hide();
                            $messageCont.hide();
                        }
                    } catch (e) {
                        $progressCont.hide();
                        $messageCont.hide();
                    }
                })
                .fail(function (errorResp) {
                    $progressCont.hide();
                    $messageCont.hide();
                });
        }
    };

    var processUserDetailsConfirmationPopup = function () {
        if (window.globalSettings.showConfirmUserDetailsPopup) {
            var $popupDialog = $();
            var saveContactDetails = function () {
                if ($popupDialog.length) {
                    var validator = $popupDialog.validate();

                    validator.resetForm();
                    var isFormValid = validator.form();
                    if (isFormValid) {
                        $popupDialog.block({ message: null });
                        $.ajax({
                            url: window.R + 'handlers/public/userdata.ashx',
                            type: 'POST',
                            data: {
                                action: 'UpdateUserContactDetails',
                                mobile: $popupDialog.find('#userDetailsConfirmationPopup_MobilePhone').val(),
                                phone: $popupDialog.find('#userDetailsConfirmationPopup_HomePhone').val(),
                                email: $popupDialog.find('#userDetailsConfirmationPopup_Email').val(),
                                address: $popupDialog.find('#userDetailsConfirmationPopup_Address').val(),
                                postalCode: ($popupDialog.find('#userDetailsConfirmationPopup_PostalCode').val() || '').trim(),
                                postalArea: $popupDialog.find('#userDetailsConfirmationPopup_PostalArea').val()
                            },
                            dataType: 'json',
                        })
                        .done(function (response) {
                            if (response.reload) {
                                window.location.reload(true);
                            } else {
                                window.PubSub.publish('notification.success', response.message);
                                $popupDialog.dialog('close');
                            }
                        })
                        .fail(ajaxFailHandler)
                        .always(function () { $popupDialog.unblock(); });
                    }
                }
            };

            var popupTemplateOverride = $('.UserDetailsConfirmationPopupContent').html();
            $.ajax({
                url: window.R + 'handlers/public/userdata.ashx',
                type: 'GET',
                data: {
                    action: 'GetConfirmationPopupDetails',
                    includeTemplate: !popupTemplateOverride
                },
                dataType: 'json',
            })
            .done(function (details) {
                var labels = details.labels;
                var popupTemplate = popupTemplateOverride || details.template;
                var popupHtml = _.template(popupTemplate, details);
                $popupDialog = $(popupHtml).dialog({
                    modal: true,
                    resizable: false,
                    title: labels.title,
                    width: 500,
                    dialogClass: 'UserDetailsConfirmationPopup',
                    appendTo: 'form',
                    buttons: [
                        {
                            text: labels.confirmAndClose,
                            icons: {
                                primary: 'ui-icon-check'
                            },
                            click: function () {
                                saveContactDetails();
                            }
                        }
                    ]
                });
            })
            .fail(ajaxFailHandler);
        }
    };

    var attachLocalStorageSavingForForms = function() {
        var inputs = $('input[data-store],textarea[data-store]');
        $.each(inputs, function() {
            var t = $(this);
            var store = t.attr('data-store');
            if (store) {
                var key = store + '-' + t.attr('id');
                var currentValue = t.val();
                if (!currentValue || currentValue.length === 0) {
                    var lsValue = window.getFromLocalStorage(key);
                    if (lsValue) {
                        t.val(lsValue);
                    }
                }

                t.keyup(function () {
                    var val = t.val();
                    if (val && val.length > 0) {
                        window.saveToLocalStorage(key, t.val());
                    } else {
                        window.removeFromLocalStorage(key);
                    }
                });
            }
        });
    };

    var setupPersonalDataDownload = function() {
        var $personalDataCont = $('.js-personal-data-cont');
        if (!$personalDataCont.length) {
            return;
        }

        var downloadClicked = false;

        var $frame = $personalDataCont.find('#downloadPersonalDataFrame');
        $frame.load(function() {
            //note: load event is invoked when an error is returned from server
            //some browsers raise frame.load event on page load - need to check if download link was clicked
            if (!downloadClicked) {
                return;
            }

            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            var errTxt = TopFormText.downloadPersonalDataError;
            var frameContent = $frame[0].contentWindow || $frame[0].contentDocument;
            var frameDoc = frameContent.document || frameContent;

            if (frameDoc &&
                frameDoc.body !== null &&
                frameDoc.body.innerText !== null &&
                frameDoc.body.innerText.length) {
                try {
                    var contentObj = JSON.parse(frameDoc.body.innerText);
                    if (contentObj && contentObj.Message) {
                        errTxt = contentObj.Message;
                    }
                } catch (e) {
                    console.error(e);
                }
            }

            window.PubSub.publish('notification.error', errTxt);
        });

        $('.js-lnk-personal-data').click(function(e) {
            e.preventDefault();
            downloadClicked = true;
            var format = $(this).data('format');

            if (format) {
                var form = document.createElement('form');
                form.action = window.R + 'handlers/public/userdata.ashx';
                form.method = 'GET';
                form.target = 'downloadPersonalDataFrame';

                var input = document.createElement('textarea');
                input.name = 'action';
                input.value = 'DownloadPersonalData';
                form.appendChild(input);

                input = document.createElement('textarea');
                input.name = 'format';
                input.value = format;
                form.appendChild(input);

                form.style.display = 'none';
                document.body.appendChild(form);
                form.submit();

                $(form).remove();
            } else {
                // ReSharper disable once UseOfImplicitGlobalInFunctionScope
                window.PubSub.publish('notification.error', TopFormText.formatNotSpecified);
            }
        });
    };

    $(function () {
        window.SetEqualHeights();

        setupFancyboxes();

        setupTooltips();

        setupDateTimeSelectors();

        setupSearchControls();

        setupNumericLimiters();

        setupValidation();

        setupNotifications();

        setupOrderConditionWarningNotifications();

        setupProductsColoring();

        processBuyFeedbackPopup();

        processUserDetailsConfirmationPopup();

        attachLocalStorageSavingForForms();

        processFreeShipingOfferPopup();

        processFreeShippingMessage();

        setupPersonalDataDownload();

        // Fix IE: teaser-picture in popup appears behind the Youtube-video.
        $('iframe').each(function () {
            var url = $(this).attr("src");
            var m = '?';
            var c = 0;
            var adds;
            if (url && url.length) {
                for (var i = 0; i < url.length; i++) {
                    if (m == url.substr(i, m.length)) c++;
                }

                if (c > 0) {
                    adds = '&';
                } else {
                    adds = '?';
                }

                if (url.indexOf("youtube") >= 0) {
                    $(this).attr("src", url + adds + "wmode=transparent");
                }
            }
        });

        //Fix double main title problem on list pages
        var articles = $('#UC137_tMain, #UC152_tMain, #UC171_documentViewMainContainer');
        if (articles.length) {
            var nextElement = articles.next('div');
            if (nextElement.hasClass('UC162') || nextElement.hasClass('UC167')) {
                nextElement.find('.MainTitle').hide();
            }
        }

        // Workaround for console in IE
        if (!window.console) {
            window.console = {
                log: function () { },
                info: function () { },
                warn: function () { },
                error: function () { }
            };
        }
    });
})(jQuery, _);

/* jQuery numeric */
(function(d){d.fn.numeric=function(a,c){"boolean"===typeof a&&(a={decimal:a});a=a||{};"undefined"==typeof a.negative&&(a.negative=!0);var g=!1===a.decimal?"":a.decimal||".",b=!0===a.negative?!0:!1;return this.data("numeric.decimal",g).data("numeric.negative",b).data("numeric.callback","function"==typeof c?c:function(){}).keypress(d.fn.numeric.keypress).keyup(d.fn.numeric.keyup).blur(d.fn.numeric.blur)};d.fn.numeric.keypress=function(a){var c=d.data(this,"numeric.decimal"),g=d.data(this,"numeric.negative"),
b=a.charCode?a.charCode:a.keyCode?a.keyCode:0;if(13==b&&"input"==this.nodeName.toLowerCase())return!0;if(13==b)return!1;var f=!1;if(a.ctrlKey&&97==b||a.ctrlKey&&65==b||a.ctrlKey&&120==b||a.ctrlKey&&88==b||a.ctrlKey&&99==b||a.ctrlKey&&67==b||a.ctrlKey&&122==b||a.ctrlKey&&90==b||a.ctrlKey&&118==b||a.ctrlKey&&86==b||a.shiftKey&&45==b)return!0;if(48>b||57<b){var h=d(this).val();if(0!=h.indexOf("-")&&g&&45==b&&(0==h.length||0==d.fn.getSelectionStart(this)))return!0;c&&b==c.charCodeAt(0)&&-1!=h.indexOf(c)&&
(f=!1);8!=b&&9!=b&&13!=b&&35!=b&&36!=b&&37!=b&&39!=b&&46!=b?f=!1:"undefined"!=typeof a.charCode&&(a.keyCode==a.which&&0!=a.which?(f=!0,46==a.which&&(f=!1)):0!=a.keyCode&&0==a.charCode&&0==a.which&&(f=!0));c&&b==c.charCodeAt(0)&&(f=-1==h.indexOf(c)?!0:!1)}else f=!0;return f};d.fn.numeric.keyup=function(){var a=d(this).value;if(a&&0<a.length){var c=d.fn.getSelectionStart(this),g=d.data(this,"numeric.decimal"),b=d.data(this,"numeric.negative");if(""!=g){var f=a.indexOf(g);0==f&&(this.value="0"+a);1==
f&&"-"==a.charAt(0)&&(this.value="-0"+a.substring(1));a=this.value}for(var h=[0,1,2,3,4,5,6,7,8,9,"-",g],f=a.length,e=f-1;0<=e;e--){var i=a.charAt(e);0!=e&&"-"==i?a=a.substring(0,e)+a.substring(e+1):0==e&&!b&&"-"==i&&(a=a.substring(1));for(var k=!1,j=0;j<h.length;j++)if(i==h[j]){k=!0;break}if(!k||" "==i)a=a.substring(0,e)+a.substring(e+1)}b=a.indexOf(g);if(0<b)for(e=f-1;e>b;e--)i=a.charAt(e),i==g&&(a=a.substring(0,e)+a.substring(e+1));this.value=a;d.fn.setSelection(this,c)}};d.fn.numeric.blur=function(){var a=
d.data(this,"numeric.decimal"),c=d.data(this,"numeric.callback"),g=this.value;""!=g&&(RegExp("^\\d+$|\\d*"+a+"\\d+").exec(g)||c.apply(this))};d.fn.removeNumeric=function(){return this.data("numeric.decimal",null).data("numeric.negative",null).data("numeric.callback",null).unbind("keypress",d.fn.numeric.keypress).unbind("blur",d.fn.numeric.blur)};d.fn.getSelectionStart=function(a){if(a.createTextRange){var c=document.selection.createRange().duplicate();c.moveEnd("character",a.value.length);return""==
c.text?a.value.length:a.value.lastIndexOf(c.text)}return a.selectionStart};d.fn.setSelection=function(a,c){"number"==typeof c&&(c=[c,c]);if(c&&c.constructor==Array&&2==c.length)if(a.createTextRange){var d=a.createTextRange();d.collapse(!0);d.moveStart("character",c[0]);d.moveEnd("character",c[1]);d.select()}else a.setSelectionRange&&(a.focus(),a.setSelectionRange(c[0],c[1]))}})(jQuery);

/* Add to shopping list popup */
(function($, _, root) {
    'use strict';
    var $addToCollectionDialog = null;
    var template = '<div title="<%- labels.addProductToShoppingList %>"><div class="form-group mb-1"><label class="form-label" for="existingShoppinglistSelector"><%- labels.selectShoppingList %></label><select id="existingShoppinglistSelector" class="form-control js-existing-shoppinglist-selector"><% _.each(shoppingLists, function(shoppingList, idx){%> <option value="<%=shoppingList.id %>" <%=shoppingList.id===0 ? \'selected="selected"\' : \'\' %>><%- shoppingList.name %></option> <%}); %> </select></div><button type="button" class="btn btn-primary btn-small js-action-button" data-action="addtoexistingshoppinglist"><%- labels.add %></button> <a href="<%=urls.myShoppingListsUrl %>" class="btn btn-link btn-small"><%- labels.myShoppingLists %></a><hr/><div class="form-group mb-1"><label class="form-label" for="newShoppinglistName"><%- labels.addToNewShoppingList %></label><input id="newShoppinglistName" type="text" class="form-control js-new-shoppinglist-name" placeholder="<%- labels.newShoppingList %>"/></div><button type="button" class="btn btn-primary btn-small js-action-button" data-action="addtonewshoppinglist"><%- labels.add %></button></div>';
    var systemUrls, labels;
    var isContextLoaded = false;
    var isAnonymous;

    root.showAddToCollectionPopup = function (products) {
        if (typeof (products) === 'undefined') {
            root.PubSub.publish('notification.warning', labels.noProductsFound);
        } else {
            if (!isContextLoaded) {
                $.when(getContext())
                    .done(function(ctx) {
                        systemUrls = ctx.urls;
                        labels = ctx.labels;
                        isContextLoaded = true;
                        isAnonymous = ctx.isAnonymous;

                        var $shoppingListSelector;
                        var $newShoppingListInput;

                        if (isAnonymous === true) {
                            showLoginRequiredWarning();
                        } else {
                            var dialogHtml = _.template(template, ctx);
                            $addToCollectionDialog = $(dialogHtml).dialog({
                                resizable: false,
                                modal: true,
                                autoOpen: false,
                                width: 400,
                                buttons: [
                                    {
                                        'class': 'btn btn-default',
                                        text: labels.close,
                                        click: function() {
                                            $(this).dialog('close');
                                        }
                                    }
                                ]
                            });

                            $shoppingListSelector = $addToCollectionDialog.find('.js-existing-shoppinglist-selector');
                            $shoppingListSelector.keyup(function(e) {
                                if (e.keyCode == 13) {
                                    _handleAddProductToExistingShoppingList();
                                }
                            });
                            $newShoppingListInput = $addToCollectionDialog.find('.js-new-shoppinglist-name');
                            $newShoppingListInput.keyup(function(e) {
                                if (e.keyCode == 13) {
                                    _handleAddProductToNewShoppingList();
                                }
                            });

                            var $addButton = $addToCollectionDialog.find("[data-action='addtoexistingshoppinglist']");
                            if (ctx.shoppingLists.length <= 0) {
                                $addButton.prop('disabled', true);
                                $addButton.prop('title', labels.emptyShoppingLists);

                                $shoppingListSelector.prop('disabled', true);
                            }

                            $addToCollectionDialog.find('.js-action-button').click(function(evt) {
                                evt.preventDefault();

                                var $clickTarget = $(evt.target);
                                var action = $clickTarget.data('action');

                                switch (action) {
                                case 'addtoexistingshoppinglist':
                                    _handleAddProductToExistingShoppingList();
                                    break;
                                case 'addtonewshoppinglist':
                                    _handleAddProductToNewShoppingList();
                                    break;
                                }
                            });

                            $addToCollectionDialog.data('products', products);
                            $addToCollectionDialog.dialog('open');
                        }

                        function _handleAddProductToExistingShoppingList() {
                            var productsToAdd = $addToCollectionDialog.data('products');
                            var selectedShoppingListId = $shoppingListSelector.val();

                            blockUI();
                            $.when(root.PublicEStore.addToShoppingList(selectedShoppingListId, productsToAdd))
                                .always(unblockUI)
                                .done(function() {
                                    root.PubSub.publish('notification.success', labels.productAddedToShoppingList);
                                    $addToCollectionDialog.dialog('close');
                                })
                                .fail(errorHandler);
                        }

                        function _handleAddProductToNewShoppingList() {
                            var productsToAdd = $addToCollectionDialog.data('products');

                            var newShoppingListName = $newShoppingListInput.val();
                            if (newShoppingListName) {
                                blockUI();
                                $.when(root.PublicEStore.addShoppingList(newShoppingListName, '', productsToAdd))
                                    .always(unblockUI)
                                    .done(function(dataContract) {
                                        var newShoppingList = dataContract.result;
                                        // Add to selector and select
                                        var $newShoppingListOption = $('<option />',
                                            { 'value': newShoppingList.shoppingListID, 'text': newShoppingList.name });
                                        $shoppingListSelector.append($newShoppingListOption);
                                        $shoppingListSelector.val(newShoppingList.shoppingListID).change();

                                        // Cleanup
                                        $newShoppingListInput.val('');

                                        // Notify
                                        root.PubSub.publish('notification.success', labels.productAddedToShoppingList);
                                        $addToCollectionDialog.dialog('close');
                                    })
                                    .fail(errorHandler);
                            } else {
                                root.PubSub.publish('notification.warning', labels.shoppingListNameIsEmpty);
                            }
                        }
                    })
                    .fail(errorHandler);
            } else if (isAnonymous === true) {
                showLoginRequiredWarning();
            } else if ($addToCollectionDialog) {
                $addToCollectionDialog.data('products', products);
                $addToCollectionDialog.dialog('open');
            }
        }

        function getContext() {
            return $.get(root.R + 'handlers/public/estoredata.ashx?a=GetAddToShoppingListContext');
        }

        function blockUI() {
            if (typeof ($.blockUI) === 'function') {
                $addToCollectionDialog.block({ message: null });
            }
        }

        function unblockUI() {
            if (typeof ($.unblockUI) === 'function') {
                $addToCollectionDialog.unblock();
            }
        }

        function errorHandler(error) {
            var message;

            if (typeof (error) === 'string') {
                message = error;
            } else {
                message = typeof (error) !== 'undefined' ? (error.message ? error.message : error.statusText) : 'Unknow error';
            }

            if (typeof (error.status) !== 'undefined' && error.status.toLowerCase() === 'unauthorized') {
                showLoginRequiredWarning();
            } else {
                root.PubSub.publish('notification.error', message);
            }
        }

        function showLoginRequiredWarning() {
            var loginUrl = typeof (systemUrls) !== 'undefined' ? $.setQueryStringParam(systemUrls.loginUrl, 'ret', encodeURIComponent(location.pathname)) : '#';
            root.PubSub.publish('notification.warning',
                {
                    text: labels.availableToRegisteredOnly + '<br /><a href="' + loginUrl + '">' + labels.loginToContinue + '</a>',
                    layout: 'center',
                    killer: true,
                    modal: true,
                    timeout: false
                });
        }
    };

    root.updateWishList = function(productId, updateType, wishListCallback) {
        $.when(getAddToWishListContext())
            .done(function(ctx) {
                systemUrls = ctx.urls;
                labels = ctx.labels;

                switch (updateType) {
                case 'add':
                    $.when(root.PublicEStore.addToWishList(productId)).then(wishListCallback, errorCallback);
                    break;
                case 'remove':
                    $.when(root.PublicEStore.removeFromWishList(productId)).then(wishListCallback, errorCallback);
                    break;
                default:
                    throw "Unknown updateType: " + updateType;
                }

                function errorCallback(dataContract) {
                    if (dataContract.status.toLowerCase() === 'unauthorized') {
                        var loginUrl = typeof (systemUrls) !== 'undefined'
                            ? $.setQueryStringParam(systemUrls.loginUrl, 'ret', encodeURIComponent(location.pathname))
                            : '#';
                        root.PubSub.publish('notification.warning',
                            {
                                text: labels.availableToRegisteredOnly + '<br /><a href="' + loginUrl + '">' + labels.loginToContinue + '</a>',
                                layout: 'topCenter',
                                timeout: 10 * 1000
                            });
                    } else if (dataContract.result) {
                        _.each(dataContract.result.items,
                            function(prod) {
                                root.PubSub.publish('notification.error', prod.message);
                            });
                    }
                }
            });

        function getAddToWishListContext() {
            return $.get(root.R + 'handlers/public/estoredata.ashx?a=GetAddToWishListContext');
        }
    }


})(jQuery, _, window);

/* Site scripts */
(function(w) {
    var ss = w.siteScripts = {};

    //Converts
    ss.converters = {};

    ss.converters.add = function (collection, converter) {
        var col = ss.converters[collection];
        if (!col) { col = ss.converters[collection] = []; }
        col.push(converter);
    };

    ss.converters.apply = function (collection, data) {
        var col = ss.converters[collection];
        if (!col) { return data; }
        col.forEach(function(f) { data = f(data); });
        return data;
    };
})(window);

/* Postal code selector */
(function ($, _, root) {
    $(function () {
        'use strict';

        var $postalCodeLnk = $('.js-postal-code-lnk');
        var $postalCodeSelector = $('.js-postal-code-selector');
        var $postalCodeLabel = $('.js-postal-code-label');
        var $noPostalCodeLabel = $('.js-no-postal-code');
        var $postalCodeValue = $('.js-postal-code-value');
        var $postalCodeLink = $('.js-postal-code-link');
        if ($postalCodeLnk.length) {
            $.when(getContext())
                .done(function (ctx) {
                    $postalCodeLnk.text(ctx.labels.yourCodeText + (ctx.currentCode ? ': ' + ctx.currentCode : ''));
                    $('head').append(ctx.showPostalCodePopup);
                    $('head').append(ctx.postalCodePopupScript);
                    $postalCodeLnk.click(function () {
                        showPostalCodePopup(); // declared in estoredata.ashx
                    });
                })
                .fail(showError);
        }

        if ($postalCodeSelector.length) {
            $.when(getContext())
                .done(function (ctx) {
                    $('head').append(ctx.showPostalCodePopup);
                    $('head').append(ctx.postalCodePopupScript);
                    if (ctx.currentCode) {
                        $postalCodeLabel.show();
                        $postalCodeValue.show();
                        $noPostalCodeLabel.hide();
                    } else {
                        $noPostalCodeLabel.show();
                        $postalCodeLabel.hide();
                        $postalCodeValue.hide();
                    }
                    $postalCodeValue.text(ctx.currentCode ? ' ' + ctx.currentCode : '');
                    $postalCodeSelector.click(function() {
                        window.showPostalCodePopup(); // declared in estoredata.ashx
                    });
                })
                .fail(showError);
        }

        if ($postalCodeLink.length) {
            $.when(getContext())
                .done(function (ctx) {
                    $('head').append(ctx.showPostalCodePopup);
                    $('head').append(ctx.postalCodePopupScript);
                    $postalCodeLink.click(function() {
                        window.showPostalCodePopup(); // declared in estoredata.ashx
                    });
                })
                .fail(showError);
        }
       
        function getContext() {
            return $.get(root.R + 'handlers/public/estoredata.ashx?a=GetPostalCodePopup');
        }

        function showError(error) {
            var message;

            if (typeof (error) === 'string') {
                message = error;
            } else {
                message = typeof (error) !== 'undefined'
                    ? (error.message ? error.message : error.statusText)
                    : 'Unknow error';
            }

            root.PubSub.publish('notification.error', message);
        }
    });
})(jQuery, window._, window);

/* External tracking */
(function($, _, root) {
    var _trackingMetadataCache = {};

    root.productListType = {
        productList: 'Product list',
        relatedProducts: 'Related products',
        bestsellers: 'Bestsellers',
        alsoBought: 'Also bought',
        searchResults: 'Search results'
    }

    // Listen to the cart changes and generate notifications to the external tracking listeners
    root.PubSub.subscribe('estore.callback.shopcart',
        function(topic, data) {
            _reportCartChange(topic, data.result.trackableMetadata);
        });
    root.PubSub.subscribe('estore.postback.shopcart',
        function(topic, data) {
            _reportCartChange(topic, data);
        });

    root.PubSub.subscribe('estore.callback.shoppinglist',
        function (topic, data) {
            _reportShoppingListChange(topic, data.result.trackableMetadata);
        });

    root.toProductListType = function (mode) {
        switch (mode) {
            case 'Bestsellers':
                return root.productListType.bestsellers;
            case 'CustomersAlsoBought':
                return root.productListType.alsoBought;
            case 'SearchResults':
            case 'SmartSearchResults':
                return root.productListType.searchResults;
            default:
                return root.productListType.productList;
        }
    }

    // trackingProductsWithLinks should be an array of objects { productId: 123, $links: $() }
    root.reportProductListView = function (productListType, productListName, trackingProductsWithLinks) {
        if (!_.isEmpty(trackingProductsWithLinks)) {
            var productListViewData = {
                currencyCode: root.globalSettings.siteCurrencyCode,
                listType: productListType,
                listName: $.trim(productListName),
                items: []
            }

            var trackingProductIds = _.map(trackingProductsWithLinks, function(product) { return product.productId; });
            $.when(_loadMetadataForTrackingProducts(trackingProductIds))
                .done(function(metadata) {
                    var trackingProductMetadataMap = {};
                    _.each(metadata,
                        function(trackingProduct) {
                            trackingProductMetadataMap[trackingProduct.productId] = trackingProduct;
                        });

                    // Remember to follow the order of tracking products, it is important for the GTM impressions where shown position is being tracked.
                    _.each(trackingProductsWithLinks,
                        function(trackingProduct) {
                            var trackingProductMetadata = trackingProductMetadataMap[trackingProduct.productId];

                            productListViewData.items.push($.extend({}, trackingProduct, trackingProductMetadata));
                        });

                    root.PubSub.publish('externaltracking.product.listview', productListViewData);
                })
                .fail(function() {
                    console.error('Failed to get tracking products metadata while reporting product list view action');
                });
        }
    };

    root.reportProductDetailsView = function(productId) {
        productId = parseInt(productId);

        if (productId > 0) {
            $.when(_loadMetadataForTrackingProducts([productId]))
                .done(function(metadata) {
                    var trackingProductDetails = metadata[0];

                    trackingProductDetails.currencyCode = root.globalSettings.siteCurrencyCode;

                    root.PubSub.publish('externaltracking.product.detailsview', trackingProductDetails);
                })
                .fail(function() {
                    console.error('Failed to get tracking products metadata while reporting product list view action');
                });
        } else {
            throw 'Invalid ProductID value';
        }
    };

    root.reportPaymentOptionSelection = function(step, paymentName) {
        var optionData = {
            step: step,
            isPaymentStep: true,
            option: 'Payment: ' + $.trim(paymentName)
        };

        _reportCheckoutOption(optionData);
    };

    root.reportDeliveryOptionSelection = function(step, deliveryName) {
        var optionData = {
            step: step,
            isDeliveryStep: true,
            option: 'Delivery: ' + $.trim(deliveryName)
        };

        _reportCheckoutOption(optionData);
    };

    root.loadMetadataForTrackingProducts = _loadMetadataForTrackingProducts;

    function _reportCartChange(topic, trackableCartChanges) {
        if (_.isEmpty(trackableCartChanges)) {
            return;
        }
        var cartChangeMetadata;
        var channelParts = topic.split('.');
        var topicAction = channelParts[channelParts.length - 1];
        var topicType = channelParts[channelParts.length - 3];
        switch (topicAction.toLowerCase()) {
        case 'addtocart':
            cartChangeMetadata = {
                source: topicType,
                currencyCode: root.globalSettings.activeCurrencyCode,
                items: trackableCartChanges
            };

            root.PubSub.publish('externaltracking.shopcart.addtocart', cartChangeMetadata);
            break;
        case 'emptycart':
        case 'removefromcart':
            cartChangeMetadata = {
                source: topicType,
                currencyCode: root.globalSettings.activeCurrencyCode,
                items: trackableCartChanges
            };

            root.PubSub.publish('externaltracking.shopcart.removefromcart', cartChangeMetadata);
            break;
        case 'updatecartquantity':
            cartChangeMetadata = {
                source: topicType,
                currencyCode: root.globalSettings.activeCurrencyCode,
                addedQtyItems: trackableCartChanges.trackableAddedQtyLinesMetadata,
                removedQtyItems: trackableCartChanges.trackableRemovedQtyLinesMetadata
            };

            root.PubSub.publish('externaltracking.shopcart.updatecartquantity', cartChangeMetadata);
            break;
        }
    }

    function _reportShoppingListChange(topic, trackableCartChanges) {
        if (_.isEmpty(trackableCartChanges)) {
            return;
        }
        var shoppingListChangeMetadata;
        var channelParts = topic.split('.');
        var topicAction = channelParts[channelParts.length - 1];
        var topicType = channelParts[channelParts.length - 3];
        switch (topicAction.toLowerCase()) {
            case 'addtowishlist':
            case 'addtoshoppinglist':
            case 'addshoppinglist':
                shoppingListChangeMetadata = {
                    source: topicType,
                    currencyCode: root.globalSettings.activeCurrencyCode,
                    items: trackableCartChanges
                };

                root.PubSub.publish('externaltracking.shoppinglist.addtowishlist', shoppingListChangeMetadata);
                break;
        }
    }

    function _reportCheckoutOption(optionData) {
        root.PubSub.publish('externaltracking.checkout.option', optionData);
    }

    function _loadMetadataForTrackingProducts(productIds) {
        // Note: the function may return data in other-than-requested order. Consider it in usages.
        var deferred = $.Deferred();

        var productMetadata = [], toFetch = [];

        _.each(productIds,
            function(productId) {
                var cached = _trackingMetadataCache[productId];
                if (cached) {
                    productMetadata.push(cached);
                } else {
                    toFetch.push(productId);
                }
            });

        if (toFetch.length > 0) {
            $.ajax({
                    url: root.R + 'api/trackingmetadata/products',
                    type: 'GET',
                    data: {
                        productIDs: toFetch
                    }
                })
                .done(function(fetchedMetadata) {
                    _.each(fetchedMetadata,
                        function(fetched) {
                            // Add to cache
                            _trackingMetadataCache[fetched.productId] = fetched;
                            // Add to results
                            productMetadata.push(fetched);
                        });

                    deferred.resolve(productMetadata);
                })
                .fail(deferred.reject);
        } else {
            deferred.resolve(productMetadata);
        }

        return deferred.promise();
    }
})(jQuery, window._, window);

/* External tracking event bus. The main purpose of this object is to be sure that all tracking systems handled event */
(function(w, factory) {
    w.ExternalTrackingEventBus = factory(w, w._);

    window.PubSub.subscribe('externaltracking.shopcart',
        function(topic, data) {
            if (!w.ExternalTrackingEventBus.hasRegisteredSystems()) {
                if (w.PubSub) {
                    var channelParts = topic.split('.');
                    var topicAction = channelParts[channelParts.length - 1];
                    w.PubSub.publish(w.ExternalTrackingEventBus.channel.event.handled, { topicAction: topicAction.toLowerCase(), data: data });
                }
            }
        });

}(window, function(w, _) {

    var _trackingSystems = {};
    var _topic = 'externaltracking';

    var supportedChannels = {
        event: {
            handled: _topic + '.event.handled'
        }
    };
    var externalTrackingEventBus = {};

    externalTrackingEventBus.channel = supportedChannels;

    externalTrackingEventBus.register = function (trackingSystem) {
        var trackingSystemsObject = _trackingSystems[trackingSystem];
        if (_.isUndefined(trackingSystemsObject)) {
            _trackingSystems[trackingSystem] = {};
        }
    };

    externalTrackingEventBus.eventHandledByAllSystems = function(event) {
        var trackingSystemsArray = _.values(_trackingSystems);

        if (trackingSystemsArray) {
            for (var i = 0; i < trackingSystemsArray.length; ++i) {
                if (!trackingSystemsArray[i][event]) {
                    return false;
                }
            }
        }

        return true;
    };

    externalTrackingEventBus.resetEvent = function (event) {
        var trackingSystemsArray = _.values(_trackingSystems);

        if (trackingSystemsArray) {
            for (var i = 0; i < trackingSystemsArray.length; ++i) {
                if (trackingSystemsArray[i][event]) {
                    trackingSystemsArray[i][event] = false;
                }
            }
        }
    };

    externalTrackingEventBus.eventHandled = function (trackingSystem, event, data) {
        var trackingSystemObject = _trackingSystems[trackingSystem];

        if (!_.isUndefined(trackingSystemObject)) {
            trackingSystemObject[event] = true;
        }

        if (this.eventHandledByAllSystems(event)) {
            this.resetEvent(event);
            if (w.PubSub) {
                w.PubSub.publish(w.ExternalTrackingEventBus.channel.event.handled, { topicAction: event, data: data });
            }
        }
    };

    externalTrackingEventBus.hasRegisteredSystems = function() {
        var trackingSystemsArray = _.values(_trackingSystems);
        return trackingSystemsArray && trackingSystemsArray.length > 0;
    };

    return externalTrackingEventBus;
    }));

/* Safely parsing of numbers */
(function ($) {
    $.mw_tryParseFloatStrict = function (value) {
        if (typeof value === 'undefined') {
            return NaN;
        }
        var ret = value.replace(',', '.');
        return $.isNumeric(ret) ? parseFloat(ret) : NaN;
    };
    $.mw_tryParseIntStrict = function (value) {
        if (typeof value === 'undefined') {
            return NaN;
        }
        var ret = value.replace(',', '.');
        return $.isNumeric(ret) ? parseInt(ret) : NaN;
    };
})(jQuery);

/* To currency formatter */
(function ($) {
    $.mw_toCurrency = function(prices, currencyCode) {
        prices = $.isArray(prices) ? prices : [prices];
        // If prices are passed as strings, ensure the decimal separator will be '.' and not ','
        var processedPrices = $.map(prices,
            function(price) {
                if (typeof (price) === 'string') {
                    return price.replace(',', '.');
                } else {
                    return price;
                }
            });

        var params = { prices: JSON.stringify(processedPrices) };
        if (currencyCode) {
            params.currency = currencyCode;
        }

        return $.get(window.R + 'handlers/public/currencyformatter.ashx', params);
    };
})(jQuery);

/* String helpers */
(function ($) {
    $.isNullOrWhiteSpace = function (str) {
        return !str || /^\s*$/.test(str);
    };

    $.isNullOrEmpty = function (str) {
        return (!str || 0 === str.length);
    };
})(jQuery);

/* Convertors */
(function($) {
    $.base64ToBlob = function base64ToBlob(base64, mime) {
        mime = mime || '';
        var sliceSize = 1024;
        var byteChars = window.atob(base64);
        var byteArrays = [];

        for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
            var slice = byteChars.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, {type: mime});
    }
})(jQuery);

